const defaultState = {
    totalProds: 0,
    searchname: ""
}

function numbersDucer( state = defaultState, { type, payload }){
    switch (type) {
        case 'totalProds': {
            return { ...defaultState,
                totalProds: payload}
        }
        case 'searchname': {
            return { ...defaultState,
                searchname: payload}
        }
        default:
            return state;
    }
}

export default numbersDucer;